import { createBrowserRouter, Navigate } from 'react-router';
import { lazy } from 'react';
import SubscriptionAndInvoices from './pages/SubscriptionsAndInvoices';
import Subscription from './pages/SubscriptionsAndInvoices/Subscription';
import Invoices from './pages/SubscriptionsAndInvoices/Invoices';
import BillingDetails from './pages/SubscriptionsAndInvoices/BillingDetails';

// Lazy load all components
const App = lazy(() => import('./App'));
const SignIn = lazy(() => import('./pages/Login/components/Signin'));
const BulkUpdate = lazy(() => import('./pages/BulkUpdate'));
const BulkUpdateCreatePage = lazy(() => import('./pages/BulkUpdateCreate'));
const Login = lazy(() => import('./pages/Login'));
const CreateProperty = lazy(() => import('./pages/Properties/CreateProperty'));
const NewSitesContainer = lazy(
  () => import('./pages/Properties/sitesContainer'),
);
const ThemesList = lazy(() => import('./pages/Themes/themesList'));
const CreateTheme = lazy(() => import('./pages/Themes/CreateTheme'));
const Vendors = lazy(() => import('./pages/Vendors'));
const BasicAnalytics = lazy(() => import('./pages/BasicAnalytics'));
const PremiumReports = lazy(() => import('./pages/PremiumReports'));
const ViewReports = lazy(
  () => import('./pages/PremiumReports/analytics/viewReports'),
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
  {
    path: '/login',
    element: <Login />,
    children: [
      {
        path: '',
        element: <SignIn />,
      },
    ],
  },
  {
    path: '/protect/:pCode',
    element: <App />,
    children: [
      {
        path: 'sites/detail/:siteId',
        element: <BasicAnalytics />,
      },
      {
        path: 'apps/detail/:appId',
        element: <BasicAnalytics />,
      },
      {
        path: 'properties',
        element: <NewSitesContainer />,
      },
      {
        path: 'sites/new',
        element: <CreateProperty />,
      },
      {
        path: 'sites/edit/:id',
        element: <CreateProperty />,
      },
      {
        path: 'app/new',
        element: <CreateProperty />,
      },
      {
        path: 'app/edit/:id',
        element: <CreateProperty />,
      },
      {
        path: 'themes',
        element: <ThemesList />,
      },
      {
        path: 'themes/site/new',
        element: <CreateTheme />,
      },
      {
        path: 'themes/site/edit/:id',
        element: <CreateTheme />,
      },
      {
        path: 'themes/app/new',
        element: <CreateTheme />,
      },
      {
        path: 'themes/app/edit/:id',
        element: <CreateTheme />,
      },
      {
        path: 'bulk-update',
        element: <BulkUpdate />,
      },
      {
        path: 'bulk-update/create',
        element: <BulkUpdateCreatePage />,
      },
      {
        path: 'vendors',
        element: <Vendors />,
      },
      {
        path: 'reports',
        element: <PremiumReports />,
      },
      {
        path: 'reports/view-reports',
        element: <ViewReports />,
      },
      {
        path: 'subscriptions',
        element: <SubscriptionAndInvoices />,
        children: [
          {
            path: '',
            element: <Subscription />,
          },
          {
            path: 'invoices',
            element: <Invoices />,
          },
          {
            path: 'billing-details',
            element: <BillingDetails />,
          },
        ],
      },
    ],
  },
]);
